<template lang="pug">
.search.page
  #bg-image-wrapper
    //- transition( name='fade' )
    //-   img( id='bg-image' :src='img' @load='showImg' v-show='show' )
  .featured-outer.small

  main( role='main' )
    h1.title Search
    //- TODO: {{ search_term ? ' Results' : ''}}
    //- TODO: search results
  .bottom-spacer
</template>

<script lang="js">

export default {
  name: 'SearchPage',
  mixins: [],
  components: {},
  props: [ 'posts', 'pagers' ],
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.search {

}
</style>
